import { render, staticRenderFns } from "./create-from.vue?vue&type=template&id=7f69489c&"
import script from "./create-from.vue?vue&type=script&lang=js&"
export * from "./create-from.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports